import { object } from 'common/helpers'


type InitialState = {
  paymentData: PurchaseDataModel.PaymentData
}

export const initialState: InitialState = {
  paymentData: null,
}

export const setPaymentData = (state, payload: PurchaseDataModel.PaymentData) => (
  object.set(state, 'paymentData', payload)
)

export const resetPaymentData = (state) => (
  object.set(state, 'paymentData', null)
)
